<script>
    import { createEventDispatcher } from 'svelte';
    import * as utils from '../js/utils.js';
    import { format } from 'svelte-i18n';

    let { 
        customProps = $bindable([]), 
        config = {add: true}, 
        onaddCustomProp, 
        onpushCustomProps, 
        onremoveCustomProp 
    } = $props();

    const dispatch = createEventDispatcher();

    let title = $derived(config.add ? $format("add") : `${$format("edit")}/${$format("delete")}`);

    $effect(() => {
        if (Array.isArray(customProps)) {
            for (let prop of customProps) {
                if (prop && prop.location) {
                    prop.location = utils.removeTags(prop.location);
                }
            }
        }
    });

    const triggerAddProp = (e) => {
        e.preventDefault();
        onaddCustomProp?.();
        dispatch("addCustomProp");
    };

    const triggerPushProps = () => {
        onpushCustomProps?.(customProps);
        dispatch("pushCustomProps", customProps);
    };

    const triggerRemoveProp = (e, index) => {
        e.preventDefault();
        onremoveCustomProp?.(index);
        dispatch("removeCustomProp", index);
    };
</script>

<div class="mb-3" style="height: 100%;overflow: hidden;clear: both;">
    <label for="customPropsHeader" class="d-block" style="clear: both;">{title} {$format("properties")}</label>
    <div class="mt-3 mb-5">
        <button 
            type="button" 
            class="btn btn-default btn-xs float-start" 
            title="Agregar más notas" 
            onclick={triggerAddProp}
        >
            <span class="float-start me-1">{$format("add")} {$format("property")} </span>
        </button>
    </div>
    {#each customProps as prop, i}
        <div class="customPropContainer">
            <label for={`customPropsKind${i}`}>{$format("type")}:</label>
            <input
                type="text"
                class="form-control mt-3 prop-input float-start"
                id={`customPropsKind${i}`}
                name={`customPropsKind${i}`}
                placeholder="Tipo"
                bind:value={customProps[i].kind}
                onblur={triggerPushProps}
            />
            <label for={`customPropsName${i}`}>{$format("form.fields.name")}:</label>
            <input
                type="text"
                class="form-control mt-3 prop-input float-start"
                id={`customPropsName${i}`}
                name={`customPropsName${i}`}
                placeholder={$format("form.fields.name")}
                bind:value={customProps[i].name}
                onblur={triggerPushProps}
            />
            <label for={`customPropsValue${i}`}>{$format("list.columns.value")}:</label>
            <input
                type="text"
                class="form-control mt-3 prop-input float-start"
                id={`customPropsValue${i}`}
                name={`customPropsValue${i}`}
                placeholder="Valor"
                bind:value={customProps[i].value}
                onblur={triggerPushProps}
            />
            <label for={`customPropsLocation${i}`}>{$format("list.columns.location")}:</label>
            <input
                type="text"
                class="form-control mt-3 prop-input float-start"
                id={`customPropsLocation${i}`}
                name={`customPropsLocation${i}`}
                placeholder="tcp://ip:nn"
                bind:value={customProps[i].location}
                onblur={triggerPushProps}
            />
            {#if config.add}
                <button 
                    type="button" 
                    class="btn btn-default" 
                    title={`${$format("remove")} ${$format("property")}`} 
                    style="margin-top:1rem; position: relative; margin-left: 0em;" 
                    onclick={(e) => triggerRemoveProp(e, i)}
                >
                    <i class="fas fa-times" style="font-size: 1rem; color: rgba(160, 33, 40, 0.9);"></i> {$format("remove")} {$format("property")}
                </button>
            {/if}
            {#if config.edit}
                <button 
                    type="button" 
                    class="btn btn-default" 
                    title={`${$format("remove")} ${$format("property")}`} 
                    style="margin-top:1rem; position: relative; margin-left: 0em;" 
                    onclick={(e) => triggerRemoveProp(e, {prop: prop, index: i})}
                >
                    <i class="fas fa-times" style="font-size: 1rem; color: rgba(160, 33, 40, 0.9);"></i> {$format("remove")} {$format("property")}
                </button>
            {/if}
        </div>
    {/each}
</div>

<style>
    label {
        display: block;
        clear: both;
    }
    .customPropContainer{
        clear: both;
        height: 100%;
        overflow: hidden;
        border: 1px solid #ccc;
        padding: 1em;
        margin-top: 1em;
    }
    .customPropContainer label {
        margin-bottom: 0;
        margin-top: 1em;
    }
    .customPropContainer input {
        margin-top: 1em;
        margin-bottom: 1em;
    }
    .prop-input{
        max-width: 94%;
    }
</style>